import {library} from "@fortawesome/fontawesome-svg-core"
import {
    faAngry,
    faArrowCircleLeft,
    faArrowCircleRight,
    faAward,
    faBaby,
    faBadgeCheck,
    faBalanceScale,
    faBan,
    faBlender,
    faBoot,
    faBriefcase,
    faBuilding,
    faBus,
    faCarSide,
    faCheck,
    faCheckCircle,
    faChevronCircleDown,
    faChevronCircleLeft,
    faChevronCircleRight,
    faChevronCircleUp,
    faChild,
    faCoins,
    faCommentAltEdit,
    faCommentsAlt,
    faCrown as falCrown,
    faDizzy,
    faFeatherAlt,
    faFemale,
    faFighterJet,
    faFileSignature,
    faFire,
    faFrown,
    faFrownOpen,
    faGavel,
    faGrin,
    faHandHoldingUsd,
    faHome,
    faIndustryAlt,
    faLaugh,
    faMale,
    faMedal,
    faMedkit,
    faMinus,
    faMoneyBillWave,
    faPassport,
    faPiggyBank,
    faQuestionCircle,
    faSadCry,
    faShip,
    faSmile,
    faStore,
    faTimes,
    faTimesCircle,
    faTired,
    faTrain,
    faTrophy,
    faTrophyAlt,
    faTruck,
    faUniversity,
    faUser,
    faUserCrown,
    faUserGraduate,
    faUsersCrown,
    faUserTie,
    faUtensilKnife,
    faWheelchair
} from "@fortawesome/pro-light-svg-icons"
import {
    faCaretDown,
    faCircle as solidCircle,
    faCrown,
    faFlag,
    faSpinnerThird,
    faSquare,
    faStar,
    faThumbsUp,
    faTrophy as trophySolid,
    faUserCircle
} from "@fortawesome/pro-solid-svg-icons"
import {
    faAnalytics,
    faBars,
    faCircle,
    faCog,
    faExternalLink,
    faGameBoard,
    faParagraph,
    faQuestion,
    faTag,
    faUser as FarUser,
    faUsers
} from "@fortawesome/pro-regular-svg-icons"

//base icons
library.add(solidCircle, faFrownOpen, faArrowCircleRight, faQuestionCircle, faSpinnerThird, faSquare, faCheck, faTimes, faExternalLink, faCheckCircle, faCircle, faAward, faCoins, faTrophyAlt, faPiggyBank, faTrophy, trophySolid, faCommentAltEdit, faFlag, faChevronCircleRight, faChevronCircleLeft, faBars, faUserCircle, faStar, faThumbsUp)

//Admin Panel
library.add(faAnalytics, faGameBoard, faParagraph, faTag, FarUser, faUsers, faCog)

//game
library.add(faBadgeCheck, faCrown, falCrown, faUserCrown, faMedal, faUsersCrown, faBoot, faBan, faTimesCircle, faQuestion, faSmile, faFrown, faGrin, faLaugh)

//top label Icons
library.add(faChild, faFemale, faMale, faHome, faBlender, faMedkit, faBuilding, faUtensilKnife, faUser, faMinus, faCarSide, faBriefcase)

//more label icons
library.add(faCaretDown, faFileSignature, faFighterJet, faUserGraduate, faIndustryAlt, faHandHoldingUsd, faBalanceScale, faGavel, faFire, faDizzy, faUniversity, faPassport, faMoneyBillWave, faSmile, faFeatherAlt, faUserTie)

//admin panel icons
library.add(faCommentsAlt, faBaby, faWheelchair, faStore, faAngry, faSadCry, faTired, faChevronCircleUp, faChevronCircleDown, faArrowCircleLeft, faTruck, faTrain, faShip, faBus)

